import React, { Component } from 'react';
import ReactTable from 'react-table';
import moment from 'moment';
import { formatMoney } from 'helpers/Formatter';

export default class InvoiceList extends Component {
  constructor(props) {
    super(props);
    const tableSize = props.invoices && props.invoices.length > 0 ? props.invoices.length : 4;
    this.state = { tableSize, data: props.invoices };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const tableSize =
      nextProps.invoices && nextProps.invoices.length > 0 ? nextProps.invoices.length : 4;
    this.setState({ tableSize, data: nextProps.invoices }, () => this.forceUpdate());
  }

  render() {
    const columns = [
      {
        header: 'Date Billed',
        headerClassName: 'headerColumn',
        accessor: 'date',
        render: row => moment(row.value).format('MMM D, YYYY'),
      },
      {
        header: 'Description',
        headerClassName: 'headerColumn',
        accessor: 'description',
      },
      {
        header: 'Amount',
        headerClassName: 'headerColumn',
        accessor: 'amount',
        render: row => formatMoney(row.value),
      },
    ];

    return (
      <div style={{ marginBottom: '70px' }}>
        <ReactTable
          data={this.state.data}
          columns={columns}
          showFilters={false}
          showPagination={false}
          showPageSizeOptions={false}
          pageSize={this.state.tableSize}
          noDataText="No Invoices"
          style={{ textAlign: 'left' }}
          getTdProps={(state, rowInfo, column, instance) => ({
            onClick: e => rowInfo.row && window.open(rowInfo.row.hosted_invoice_url, '_blank'),
          })}
        />
      </div>
    );
  }
}
